/* global process:false */

export const ROUTER_PATH_BASE = process.env.REACT_APP_ROUTER_PATH_BASE as string
export const ASSETS_PATH_BASE = process.env.REACT_APP_ASSETS_PATH_BASE as string
export const ON_ERROR_REDIRECT_TO = process.env.REACT_APP_ON_ERROR_REDIRECT_TO as string
